import React, { useEffect, useRef } from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import cloudIcon from '../assets/svgs/usecaseCloud.svg';
export interface UseCase {
  id: number;
  heading: string;
  descriptionPoints: string[];
  buttonText: string;
  imageSrc: any;
  imageAlt: string;
  imageOnLeft?: boolean;
  fullContent: {
    title: string;
    paragraphs: string[];
    conclusionHeading: string;
    conclusionParagraphs: string[];
  };
}

interface UseCaseModalProps {
  useCase: UseCase;
  onClose: () => void;
}

const UseCaseModal: React.FC<UseCaseModalProps> = ({ useCase, onClose }) => {
  const modalContentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    if (modalContentRef.current) {
      modalContentRef.current.focus();
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  return (
    <div className="use-case-modal-overlay" onClick={onClose}>
      <div
        className="use-case-modal-content"
        onClick={(e) => e.stopPropagation()}
        ref={modalContentRef}
        tabIndex={-1}
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
      >
        <button
          className="modal-close-button"
          onClick={onClose}
          aria-label="Close modal"
        >
          <IoCloseSharp />
        </button>

        <h2 id="modal-title" className="modal-title">
          {useCase.fullContent.title}
        </h2>

        {useCase.fullContent.paragraphs.map((paragraph, index) => {
          const parts = paragraph.split(/(Cumulus)/g); // split by the word "Cumulus"
          return (
            <p key={index} className="modal-paragraph">
              {parts.map((part, i) =>
                part === 'Cumulus' ? <strong key={i}>Cumulus</strong> : part
              )}
            </p>
          );
        })}

        {/* Cloud icon */}
        <div className="modal-cloud-icon-container">
          <img src={cloudIcon} alt="Cloud Icon" className="modal-cloud-icon" />
        </div>

        <div className="modal-conclusion">
          <h3 className="modal-conclusion-heading">
            {useCase.fullContent.conclusionHeading}
          </h3>
          {useCase.fullContent.conclusionParagraphs.map((paragraph, index) => {
            const parts = paragraph.split(/(Cumulus)/g);
            return (
              <p key={index} className="modal-paragraph">
                {parts.map((part, i) =>
                  part === 'Cumulus' ? <strong key={i}>Cumulus</strong> : part
                )}
              </p>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default UseCaseModal;
